
<template>
    <div class="is-inline-block">
        <StreamBarcodeReader
            @decode="onDecode"
            @loaded="onLoaded"
        ></StreamBarcodeReader>
    </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: 'bulma_cameraScanner',
    components: { StreamBarcodeReader },
    data() {
        return {
            isCameraSupported: false,
            errorMessage: '',
            mediaStream: null,
            isSafari: false,
            capturedImages: [],
            imgLimit: 3,
            maxReached: false,
            cameraWorking: false,
            showSpinner: false, 
        }
    },
  
  computed: {},
  mounted() {},
  methods: {
    onDecode(text) {
        // console.log(`Decode text from QR code is ${text}`)
        this.$emit('saveCode', text)
    },
    onLoaded() {
        console.log(`Ready to start scanning barcodes`)
    },
    
    stopCamera() {
      if (this.mediaStream) {
        this.mediaStream.getTracks().forEach(track => track.stop())
        this.mediaStream = null
      }
    }
    
  }
}
</script>

<style>

.video {
    /* width: 1920px;
    height: 1080px; */
    min-width: 640px;
    /* max-width: 1920px !important; */
    min-height: 480px;
    /* max-height: 1080px !important; */
}
</style>